let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("2ABJz")).then(() => parcelRequire('7Shff'));